<template>
  <div>
    <InspectDetail ref="InspectDetail" />
  </div>
</template>

<script>
import InspectDetail from "@/views/Inspect/components/InspectDetail.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: { InspectDetail },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState("fengxian", ["jieguo"]),
    fengxianVisible: {
      get() {
        return this.$store.state.fengxian.fengxianVisible;
      },
      set(val) {
        this.setFengxianVisible(val);
      },
    },
  },
  watch: {
    fengxianVisible(val) {
      if (val) {
        if (this.jieguo.detectionId) {
          this.$refs.InspectDetail.show(this.jieguo.detectionId, "mode");
        }
      }
    },
  },
  methods: {
    ...mapActions("fengxian", ['setFengxianVisible']),
  },
};
</script>

<style scoped lang="scss"></style>
